import script from "./ProfileGeneral.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileGeneral.vue?vue&type=script&setup=true&lang=js"

import "./ProfileGeneral.vue?vue&type=style&index=0&id=4d4694ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d4694ea"]])

export default __exports__